import React, { useState } from 'react';
import { object, func } from 'prop-types';
import { get, size, isEmpty, toUpper, replace } from 'lodash';
import { Modal, FlexContainer, FormInput, ConfirmFooterButtons, DrawerError, Text, Divider } from '../../common';
import { Mutation } from '../../graphql';
import UPDATE_CATEGORIES from '../../../queries/UPDATE_CATEGORIES';
import { onlyNumbers, onlyLetters } from '../../../utils/Regex';

const ModifyCategory = ({ editModal, setEditModal }) => {
    const initialHall = get(editModal, 'hall', null);
    const [hall, setHall] = useState(null);
    const [sector, setSector] = useState(null);
    const onClose = () => {
        setHall(null);
        setSector(null);
        setEditModal({ visible: false });
    };
    const onHallError = () => {
        if (parseInt(hall) < 1 || parseInt(hall) > 99 || size(hall) > 2) return 'Nro. no válido';
        if (isEmpty(hall)) return 'Complete campo';
    };
    const onSectorError = () => ((sector !== null && isEmpty(sector)) || size(sector) > 1) && 'Sector no válido';
    const confirmDisabled = () => isEmpty(editModal) || isEmpty(hall) || (initialHall === `${hall || ''}${sector || ''}`) || onHallError() || onSectorError();
    return (
        <Modal
            title='Asignar pasillo'
            visible={get(editModal, 'visible', false)}
            onClose={onClose}
            width={310}
        >
            <Mutation
                mutation={UPDATE_CATEGORIES}
                refetchQueries={['getCategories']}
                onCompleted={() => onClose()}
                onError={<DrawerError onCancel={onClose} />}
            >
                {({ updateFn, loading, data }) => {
                    const status = get(data, 'updateCategories.status');
                    if (status !== '200' && status !== undefined) return <DrawerError onCancel={onClose} />;
                    return (
                        <>
                            <FlexContainer height={200} direction='column'>
                                <FlexContainer direction='column'>
                                    <Text text='Información actual' semibold size={14} />
                                    <Text text={`Pasillo : ${initialHall || '-'}`} semibold color='#969696' size={11} />
                                    <Divider />
                                </FlexContainer>
                                <FlexContainer justify='center'>
                                    <FormInput
                                        label='Nro. de pasillo'
                                        onlyNumbers
                                        value={hall || ''}
                                        onChange={({ target }) => setHall(replace(get(target, 'value', ''), onlyNumbers, ''))}
                                        error={hall !== null && onHallError()}
                                        style={{ maxWidth: '95px' }}
                                    />
                                    <div style={{ minWidth: '27px' }} />
                                    <FormInput
                                        label='Sector'
                                        onlyLetters
                                        value={toUpper(sector) || ''}
                                        onChange={({ target }) => setSector(replace(toUpper(get(target, 'value', '')), onlyLetters, ''))}
                                        error={onSectorError()}
                                        style={{ maxWidth: '95px' }}
                                    />
                                </FlexContainer>
                            </FlexContainer>
                            <ConfirmFooterButtons
                                loading={loading}
                                justify='center'
                                onCancel={onClose}
                                confirmDisabled={confirmDisabled()}
                                onConfirm={async () => updateFn({
                                    variables: {
                                        params: {
                                            categoryId: parseInt(get(editModal, 'categoryId')),
                                            salesChannel: get(editModal, 'salesChannel'),
                                            categoryChildrenId: parseInt(get(editModal, 'categoryChildrenId')),
                                            hall: `${hall}${sector || ''}`
                                        }
                                    }
                                })}
                            />
                        </>
                    );
                }}
            </Mutation>
        </Modal>
    );
};

ModifyCategory.propTypes = {
    editModal: object,
    setEditModal: func
};

ModifyCategory.defaultProps = {
    editModal: {},
    setEditModal: () => {}
};

export default ModifyCategory;
